'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { excludeComponentProps } from '../../utils/excludeComponentProps';
import { NavItem } from '../NavItem';
import { NavItemButton } from '../NavItemButton';
import { NavItemDropdown } from '../NavItemDropdown';
import { getContainerMaxWidth } from '../../helpers/getContainerMaxWidth';
import { navCssClassNames } from '../navCssClassNames';
const StyledNav = styled('nav')(({ theme, isSticky }) => {
    return {
        display: 'block',
        padding: `0 ${theme.tokens.FuelSpacing2}`,
        backgroundColor: `${theme.tokens.FuelColorWhite}`,
        borderBottom: `solid 1px ${theme.tokens.FuelColorBorderLight}`,
        gridArea: 'top-nav',
        ...isSticky && {
            position: 'sticky',
            top: '48px',
            zIndex: `${theme.zIndex.modal}`
        }
    };
});
const HorizontalNavList = styled('ul', excludeComponentProps('isContained'))(({ theme, isContained }) => ({
    margin: '0 auto',
    padding: 0,
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'start',
    maxWidth: getContainerMaxWidth(theme, isContained),
    '.NavItem-root': {
        display: 'inline-block'
    }
}));
export const TopNav = forwardRef(({ children, items, isContained, hasDivider, className, ...props }, ref) => {
    return (_jsx(StyledNav, { className: clsx(navCssClassNames.variantTop, 'TopNav-root', className), ref: ref, ...props, children: _jsx(HorizontalNavList, { className: navCssClassNames.list, isContained: isContained, children: children ?? items?.map(({ label, subNavigationItems, ...itemProps }, itemIndex) => (_jsx(NavItem, { children: subNavigationItems?.length ? (_jsx(NavItemDropdown, { ...itemProps, hasDivider: hasDivider, items: subNavigationItems, children: label })) : (_jsx(NavItemButton, { ...itemProps, children: label })) }, itemIndex))) }) }));
});
TopNav.displayName = 'TopNav';
